import courierRules from "@/constants/CourierRules";
import {courierDetail as _COURIERS_} from "@/config/courierCodes";
import Vue from "vue";
import { setCookie , getCookie, IsJsonString } from "@/helpers/util.js";
const vm = new Vue();

export default class Temp {
  constructor(courierCode) {
    this.courierCode = courierCode;
  }
  _VUE = vm;
  listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));

  checkZone(postcode, fixCourierCode = this.courierCode) {
    let zone;
    if (!this.listPostcodeSpecial.hasOwnProperty(fixCourierCode)) {
      return (zone = null);
    }
    if (this.listPostcodeSpecial[fixCourierCode].hasOwnProperty("zone")) {
      zone = Object.values(
        this.listPostcodeSpecial[fixCourierCode].zone
      ).findIndex((zip) => {
        let index = zip.findIndex((code) => {
          return code == postcode;
        });
        return index > -1;
      });
      zone = zone < 0 ? -1 : (zone += 1);
    } else {
      zone = null;
    }
    return zone;
  }
  checkSameProviceByName(item) {
    return (
      (!item.source && item.province.sameData == item.province.to) ||
      (item.source && item.province.from == item.province.to)
    );
  }

  checkRemoteArea(postcode) {
    let remote_area_rate = 0;
    if (!this.listPostcodeSpecial.hasOwnProperty(this.courierCode)) {
      return remote_area_rate;
    }
    if (
      this.listPostcodeSpecial[this.courierCode].hasOwnProperty("remotearea")
    ) {
      Object.values(
        this.listPostcodeSpecial[this.courierCode].remotearea
      ).forEach((res, index) => {
        let zip = res.postcode.includes(postcode);
        if (zip == true) {
          return (remote_area_rate = res.cost);
        }
      });
    }
    return remote_area_rate;
  }
  calculateDimensionWeight(item, dimensionRatio) {
    if (dimensionRatio) {
      console.log('use custom dimension ratio =>', dimensionRatio)
      courierRules[this.courierCode].dimensionRatio = dimensionRatio;
    }
    if (
      courierRules[this.courierCode] &&
      courierRules[this.courierCode].dimensionRatio
    ) {
      console.log('dimension weight:', Math.ceil(
        (Math.ceil(+item.size.width) *
          Math.ceil(+item.size.length) *
          Math.ceil(+item.size.height) *
          1000) /
          courierRules[this.courierCode].dimensionRatio || 6000
      ))
      
      return Math.ceil(
        (Math.ceil(+item.size.width) *
          Math.ceil(+item.size.length) *
          Math.ceil(+item.size.height) *
          1000) /
          courierRules[this.courierCode].dimensionRatio || 6000
      );
    }
    return item.weight;
  }
  checkRules(item, validate) {
    if (courierRules[this.courierCode]) {
      let checkDimension = true;
      let sizes = {
        width: Math.ceil(+item.size.width),
        length: Math.ceil(+item.size.length),
        height: Math.ceil(+item.size.height),
      };
      Object.keys(sizes).forEach((key) => {
        if (sizes[key] <= 0) {
          checkDimension = false;
          validate.dimension[key].status = false;
          validate.dimension[key].msg = "กรุณากรอกขนาดพัสดุ";
        } else if (sizes[key] > courierRules[this.courierCode].maxSize[key]) {
          checkDimension = false;
          validate.dimension[key].status = false;
          validate.dimension[key].msg =
            "ขนาดต้องไม่เกิน " +
            courierRules[this.courierCode].maxSize[key] +
            " ซม.";
        } else {
          validate.dimension[key].status = true;
          validate.dimension[key].msg = "";
        }
      });

      if (
        courierRules[this.courierCode].maxWLH &&
        sizes.width + sizes.length + sizes.height >
          courierRules[this.courierCode].maxWLH
      ) {
        checkDimension = false;
        validate.checkDimension.status = false;
        validate.checkDimension.msg =
          "ขนาดพัสดุรวมกันต้องไม่เกิน " +
          courierRules[this.courierCode].maxWLH +
          " ซม.";
      }

      if (checkDimension == false) {
        item.index = -1;
      }
      if (
        courierRules[this.courierCode].maxWeight &&
        item.weight > courierRules[this.courierCode].maxWeight
      ) {
        item.index = -1;
      }
      if (
        courierRules[this.courierCode].minWeight &&
        item.weight < courierRules[this.courierCode].minWeight
      ) {
        item.index = -1;
      }
    }

    return {
      index: item.index,
    };
  }
  checkCourierDimension(dimensionCourier, item, validate) {
    let sizes = {
      width: Math.ceil(+item.size.width),
      length: Math.ceil(+item.size.length),
      height: Math.ceil(+item.size.height),
    };
    let total = 0;
    let sumWLH = sizes.width + sizes.length + sizes.height;
    let dimensionWeight = 0;
    let check = true;
    let index = -1;

    Object.keys(sizes).forEach((key) => {
      if (sizes[key] <= 0) {
        check = false;
        validate.dimension[key].status = false;
        validate.dimension[key].msg = "กรุณากรอกขนาดพัสดุ";
      } else {
        validate.dimension[key].status = true;
        validate.dimension[key].msg = "";
      }
    });
    if (check === true) {
      if (
        (dimensionCourier[item.index].dimension == "" ||
        !dimensionCourier[item.index].dimension)
      ) {
        let overSize = Object.values(sizes).filter((size) => {
          return size > courierRules[this.courierCode].maxSize;
        });
        if (overSize.length > 0) {
          check = false;
          validate.checkDimension.status = false;
          validate.checkDimension.msg =
            "ขนาดพัสดุด้านใดด้านหนึ่งต้องไม่เกิน " +
            courierRules[this.courierCode].overSize +
            " ซม.";
        } else if (
          sizes.width + sizes.length + sizes.height >
          courierRules[this.courierCode].maxWLH
        ) {
          check = false;
          validate.checkDimension.status = false;
          validate.checkDimension.msg =
            "ขนาดพัสดุรวมกันต้องไม่เกิน " +
            courierRules[this.courierCode].maxWLH +
            " ซม.";
        } else {
          //cal dimension weight
          total =
            Math.ceil(((Math.ceil(sizes.width) * Math.ceil(sizes.length) * Math.ceil(sizes.height)) /
              courierRules[this.courierCode].dimensionRatio) *
            1000);


          total = Math.round(total);
          dimensionWeight = total;
          if (total <= +dimensionCourier[item.index].max) {
            check = true;
            index = item.index;
            validate.checkDimension.status = true;
            validate.checkDimension.msg = "";
          } else {
            index = dimensionCourier.findIndex((rate) => {
              return total >= +rate.min && total <= +rate.max;
            });
            
            if (courierRules[this.courierCode].allowOverWeight && courierRules[this.courierCode].maxDimensionWeight >= total) {
              index = dimensionCourier.length-1; // max tier
            }
            if (index < 0) {
              check = false;
              validate.checkDimension.status = false;
              validate.checkDimension.msg = "ขนาดพัสดุเกินกำหนด";
            }
          }
        }
      } else {
        if (
          (!courierRules[this.courierCode].calculateDimensionWeightAt || // ขนส่งทั่วไป
            courierRules[this.courierCode].calculateDimensionWeightAt < sumWLH // คิด dimension ตั้งแต่ sumWLH ++ 
          ) &&
          courierRules[this.courierCode].dimensionRatio) {
          if (['KRYQ', 'KRYS'].includes(this.courierCode)) {
            console.log('kerry weight ja', item.weight)
            if (item.weight > 20000) {
              console.log('dim 6000')
              courierRules[this.courierCode].dimensionRatio = 6000;
            } else {
              courierRules[this.courierCode].dimensionRatio = 3000;
            }
          } 
          dimensionWeight =
              ((sizes.width * sizes.length * sizes.height) /
              courierRules[this.courierCode].dimensionRatio) *
              1000;
          dimensionWeight = Math.ceil(dimensionWeight);

          if (
            dimensionWeight > item.weight ||
            courierRules[this.courierCode].useDimensionWeightOnly
          ) {
            index = dimensionCourier.findIndex((rate) => {
              return dimensionWeight >= +rate.min && dimensionWeight <= +rate.max;
            });
          } else {
            index = item.index;
          }
        }

        total = Object.values(sizes).reduce((sum, num) => {
          return sum + Number(num);
        }, 0);

        if (total > +dimensionCourier[item.index].dimension) {
          let newIndex = dimensionCourier.findIndex((rate) => {
            return total <= +rate.dimension;
          });
          if (courierRules[this.courierCode].dimensionRatio) {
            index = (index > newIndex || index == -1) ? index : newIndex;
          } else {
            index = index > newIndex ? index : newIndex;
          }
          if (index < 0 || newIndex < 0) {
            check = false;
            validate.checkDimension.status = false;
            validate.checkDimension.msg = "ขนาดพัสดุเกินกำหนด";
          }
        } else {
          check = true;
          if (!courierRules[this.courierCode].useDimensionWeightOnly) {
            if (
              (!courierRules[this.courierCode].calculateDimensionWeightAt ||
                courierRules[this.courierCode].calculateDimensionWeightAt < sumWLH
              ) &&
              courierRules[this.courierCode].dimensionRatio) {
              index = (index > item.index || index == -1) ? index : item.index;
            } else {
              index = (index > item.index) ? index : item.index;
            }
            // index = (index > item.index || index == -1) ? index : item.index;
          }
          validate.checkDimension.status = true;
          validate.checkDimension.msg = "";
        }
      }
    } else {
      check = false;
      validate.checkDimension.status = false;
      validate.checkDimension.msg = "ขนส่งนี้จำเป็นต้องระบุขนาดพัสดุ";
    }

    let res = {
      status: check,
      data: {
        index: index,
        dimension: total,
        ...sizes,
        dimensionWeight,
        rateTier: dimensionCourier[index]
      },
    };

    return res;
  }

  checkSizeKey(
    item,
    defaultSize,
    fixSize = [],
    option = {type: "code", weight: false}
  ) {
    return new Promise((resolve) => {
      let indexSize = defaultSize.findIndex((dataSize) => {
        if (fixSize.includes(dataSize.code)) {
          return (
            item.size.width <= dataSize.width &&
            item.size.length <= dataSize.length &&
            item.size.height <= dataSize.height &&
            (option.weight ? item.weight <= dataSize.weight : true)
          );
        } else {
          return (
            Number(item.size.width) +
              Number(item.size.length) +
              Number(item.size.height) <=
              dataSize.totalSize &&
            (option.weight ? item.weight <= dataSize.weight : true)
          );
        }
      });

      if (option.type == "index") {
        resolve(indexSize ? indexSize : null);
      } else {
        resolve(defaultSize[indexSize] ? defaultSize[indexSize].code : null);
      }
    });
  }

  addressCorrector(addressRemote) {
    let _SELF = vm;
    return new Promise((resolve) => {
      if (addressRemote.length < 3) {
        return resolve({status: 0, data: []});
      }
      _SELF.$http
        .post(
          _SELF.$API_URL + "/address-corrector",
          {address: addressRemote},
          {headers: {Token: localStorage.getItem("access_token")}}
        )
        .then((res) => {
          let data = res.data.data;
          if (!data) {
            resolve({status: 0, data: []});
          } else {
            resolve(data);
          }
        })
        .catch(() => {});
    });
  }

  getRemoteArea(addressRemote, courierName) {
    let _SELF = vm;
    return new Promise((resolve) => {
      if (addressRemote.length < 3) {
        return resolve({status: 0, data: []});
      }
      _SELF.$http
        .post(
          _SELF.$API_URL + "/remote/area",
          {address: addressRemote},
          {headers: {Token: localStorage.getItem("access_token")}}
        )
        .then((res) => {
          let data = res.data.data;
          if (!data) {
            resolve({status: 0, data: []});
          } else {
            if (
              // หมอมั่นใจ
              data.status === 1 &&
              ((data.data.hasOwnProperty("isRemote") &&
                data.data.isRemote.includes(courierName)) ||
                (data.data.hasOwnProperty("isRemote100") &&
                  data.data.isRemote100.includes(courierName)) ||
                (data.data.hasOwnProperty("isIsland") &&
                  data.data.isIsland.includes(courierName)))
            ) {
              resolve(true);
            } else if (data.status === 0) {
              // หมอไม่มั่นใจเชื่อตัวเองเก็บตังนะ
              resolve(true);
            } else {
              resolve(false);
            }
          }
        });
    });
  }
  getArea(addressRemote = [], courierCode =[], option) {
    let _SELF = vm;
    return new Promise((resolve) => {
      if (addressRemote.length < 1 || (addressRemote && addressRemote[0].length < 10)) {
        return resolve({status: 0, data: []});
      }
      _SELF.$http
        .post(
          _SELF.$API_URL + "/area",
          {
            text: addressRemote,
            courier_code: courierCode
          },
          {headers: {Token: localStorage.getItem("access_token")}}
        )
        .then((res) => {
          let data = res.data.data[0];
          console.log('res area', res);
          if (data.searched.length == 1) {
            resolve({
              status: 1, 
              data: data.searched[0]['courier'], 
              original_data: data.searched[0]
            });
          } else {
            let returnData = {};
            courierCode.forEach((code, index) => {
              returnData[code] = {
                is_remote: option.remote_area.rate?option.remote_area.rate:0,
                is_island: option.remote_area.is_island?option.remote_area.is_island:0,
                is_tourist: option.remote_area.is_tourist?option.remote_area.is_tourist:0
              }
            }) 
            resolve({status: 0, data: returnData});
          }
        });
    });
  }
  getCourierZone(courierCode) {
    // get kerry zone province
    let _SELF = vm;
    return new Promise((resolve) => {
      // console.log('zone is json=>', IsJsonString(getCookie('courier-zone:' + courierCode)));
      if (getCookie('courier-zone:' + courierCode) && IsJsonString(getCookie('courier-zone:' + courierCode))) {
        // console.log('use cache', getCookie('courier-zone:' + courierCode))
        resolve({status:0, data: JSON.parse(getCookie('courier-zone:' + courierCode))});
      } else {
        _SELF.$http
          .get(
            _SELF.$API_URL + "/courier-zone?courier_code=" + courierCode,
            
            {
              headers: {
                Token: localStorage.getItem("access_token")
              }
            }
          )
          .then((res) => {
            let zoneArea = res.data.data;
            setCookie('courier-zone:' + courierCode, JSON.stringify(zoneArea), '1hr');
            resolve({status: 0, data: zoneArea});
          });
      }
    });
  }
  checkTravelSurcharge(postcode) {
    let travel_surcharge = 0;
    if (!this.listPostcodeSpecial.hasOwnProperty(this.courierCode)) {
      return travel_surcharge;
    }
    if (
      this.listPostcodeSpecial[this.courierCode].hasOwnProperty("travel_surcharge")
    ) {
      let zip = this.listPostcodeSpecial[this.courierCode].travel_surcharge.postcode.includes(postcode);
      if (zip == true) { 
        return (travel_surcharge = this.listPostcodeSpecial[this.courierCode].travel_surcharge.cost);
      }
    }
    return travel_surcharge;
  }
  calculateOverweight(shipmentWeightUnitG, maxWeightUnitG, per = 1000) {
    let overweight = shipmentWeightUnitG - maxWeightUnitG;
    overweight = Math.ceil(overweight / per);
    return overweight
  }
  checkIslandSurcharge(postcode) {
    let island_surcharge = 0;
    if (!this.listPostcodeSpecial.hasOwnProperty(this.courierCode)) {
      return island_surcharge;
    }
    if (
      this.listPostcodeSpecial[this.courierCode].hasOwnProperty("island_surcharge")
    ) {
      let zip = this.listPostcodeSpecial[this.courierCode].island_surcharge.postcode.includes(postcode);
      if (zip == true) { 
        return (island_surcharge = this.listPostcodeSpecial[this.courierCode].island_surcharge.cost);
      }
    }
    return island_surcharge;
  }
  getRemoteAreaNew(addressRemote, courierName) {
    let _SELF = vm;
    let courierTouristName = courierName;
    if (courierName == 'ninjavan') {
      courierTouristName = 'njv';
    }
    return new Promise((resolve) => {
      if (addressRemote.length < 3) {
        return resolve({status: 0, data: []});
      }
      _SELF.$http
        .post(
          _SELF.$API_URL + "/remote/area",
          {address: addressRemote},
          {headers: {Token: localStorage.getItem("access_token")}}
        )
        .then((res) => {
          let data = res.data.data;
          if (!data) {
            resolve({status: 0, data: []});
          } else {
            let returnResult = {
              isRemote: false,
              isTravelArea: false,
              isIsland: false
            };
            console.log('address', data);
              // hotfix hard code travel_surcharge
            if (data.status === 1) { // หมอมั่นใจ
              if (
                data.data.zone && 
                (data.data.zone[courierTouristName] && data.data.zone[courierTouristName] == 'tourist')
              ) {
                returnResult.isTravelArea = true;
              } else {
                returnResult.isTravelArea = false;
              }
              
              if (
                data.data.hasOwnProperty("isIsland") &&
                data.data.isIsland.includes(courierName)
              ) {
                console.log('check island true');
                returnResult.isIsland = true;
              } else {
                console.log('check island false');
                returnResult.isIsland = false;
              }
            }
            
            if (
              // หมอมั่นใจ
              data.status === 1 &&
              ((data.data.hasOwnProperty("isRemote") &&
                data.data.isRemote.includes(courierName)) ||
                (data.data.hasOwnProperty("isRemote100") &&
                  data.data.isRemote100.includes(courierName)))
            ) {
              returnResult.isRemote = true;
              returnResult.postcode = data.data.zipcode.original; // FIX CODE FOR FLE
            } else if (data.status === 0) {
              // หมอไม่มั่นใจเชื่อตัวเองเก็บตังนะ
              returnResult.isRemote = true;
            }
            resolve(returnResult)
          }
        });
    });
  }
  getFuelSurcharge() {
    let _SELF = vm;
    return new Promise((resolve) => {
      if (!this.courierCode) {
        return resolve({status: 0, msg: "missing courier code"});
      }
      _SELF.$http
        .get(
          _SELF.$API_URL + "/fuel-surcharge?courier_code=" + this.courierCode,
          {},
          {headers: {Token: localStorage.getItem("access_token")}}
        )
        .then((res) => {
          let data = res.data.data;
          console.log("get fuel api=>", res.data);
          if (res.data.status) resolve(data);
          else resolve();
        });
    });
  }

  async scgFuelSurcharge(keySize, fuelPrefix) {
    let fuel_surcharge_data = await this.getFuelSurcharge();
    if (fuel_surcharge_data) {
      if (
        ["Envelop", "PM", "PL", "40", "50", "60", "70", "80"].includes(keySize)
      ) {
        fuelPrefix += "LTE_S80";
      } else {
        // > S80
        fuelPrefix += "GTE_S90";
      }
      return fuel_surcharge_data[fuelPrefix]
        ? fuel_surcharge_data[fuelPrefix]
        : 0;
    } else {
      return 0;
    }
  }
}
